// Đăng xuất ⇒ trình duyệt này thôi nhận Web Push.
//
// Sự cố 21/10/2026: nhân viên đã thoát hub.cnvwork.com vẫn nhận banner Chrome «Tin nhắn mới từ <khách>»
// kèm nội dung tin. Đăng ký push của trình duyệt sống độc lập với phiên đăng nhập — xoá localStorage
// không chạm tới nó. Máy chủ đã chặn ở cửa gửi (pushService.listSaasSubscriptions lọc theo phiên) và
// /auth/logout gỡ dòng của phiên; ở đây huỷ luôn đăng ký phía trình duyệt ⇒ hãng push trả 410 cho mọi
// dòng cũ còn trỏ tới trình duyệt này (kể cả dòng đăng ký trước khi có phiên) ⇒ máy chủ tự gỡ.
//
// Đăng nhập lại: WebPushRegister (cnv-ui) không thấy đăng ký ⇒ tạo cái mới, gắn vào phiên mới.
// Best-effort tuyệt đối — thao tác THOÁT không được kẹt vì trình duyệt không hỗ trợ / SW lỗi.

export async function unsubscribeWebPush() {
  try {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return false;
    const reg = await navigator.serviceWorker.getRegistration('/');
    const sub = await reg?.pushManager?.getSubscription();
    if (!sub) return false;
    return await sub.unsubscribe();
  } catch {
    return false;
  }
}
